import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "action-layer" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['action-layer__galleries'])
}

import EffectsCarouselPreloaderVue from '@/components/effect/EffectsCarouselPreloader.vue'
import ActionMenu from '@/components/action-menu/ActionMenu.vue'
import BackgroundGallery from '@/components/background/BackgroundGallery.vue'
import TextGallery from '@/components/text/TextGallery.vue'
import StickerGallery from '@/components/sticker/StickerGallery.vue'
import EffectsGallery from '@/components/effect/EffectGallery.vue'
import { useApplicationStore, ActionMenuTabs } from '@/store/application-store'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionLayer',
  setup(__props) {

const applicationStore = useApplicationStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EffectsCarouselPreloaderVue),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ActionMenu),
      _withDirectives(_createVNode(BackgroundGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).BACKGROUND]
      ]),
      _withDirectives(_createVNode(TextGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).TEXT]
      ]),
      _withDirectives(_createVNode(StickerGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).STICKERS]
      ]),
      _withDirectives(_createVNode(EffectsGallery, { class: "action-layer__gallery" }, null, 512), [
        [_vShow, _unref(applicationStore).activeActionTab === _unref(ActionMenuTabs).EFFECTS]
      ])
    ])
  ]))
}
}

})